import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import { trackEvent } from 'src/web/Utils/trackEvent';
import styled from 'styled-components';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFaq = (idx) => setOpenIndex(openIndex === idx ? null : idx);

  const listFaq = [
    {
      q: <p>Bagaimana Cara Mendaftar Kelas dan Melakukan Pembayaran?</p>,
      a: (
        <div>
          <ul>
            <li>
              Pastikan kamu sudah memiliki akun, atau melakukan registrasi akun terlebih dahulu di
              halaman{' '}
              <a className="link-1" href="https://myedusolve.com/register">
                https://myedusolve.com/register
              </a>
            </li>
            <li>Pilih paket pembelajaran atau kelas yang ingin diikuti.</li>
            <li>Pilih metode pembayaran yang diinginkan.</li>
            <li>Lanjutkan proses pembayaran hingga selesai.</li>
            <li>
              Setelah pembayaran berhasil, kamu dapat mengakses kelas melalui menu Profil > Kelas
              Saya.
            </li>
          </ul>
        </div>
      ),
    },
    {
      q: <p>Bagaimana Cara Mengakses Kelas Setelah Pembayaran Berhasil?</p>,
      a: (
        <div>
          <ul>
            <li>
              Login ke akun MyEduSolveX menggunakan email yang sama dengan saat pembelian, atau
              langsung akses{' '}
              <a href="https://myedusolvex.com/student/course" className="link-1">
                https://myedusolvex.com/student/course
              </a>
              .
            </li>
            <li>Pilih kelas yang telah kamu beli.</li>
            <li>Klik Mulai Pembelajaran untuk memulai kelas.</li>
            <li>
              <p>Ikuti alur pembelajaran berikut:</p>
              <ul>
                <li>Kerjakan Pre-Test.</li>
                <li>Tonton video pembelajaran secara penuh.</li>
                <li>Kerjakan quiz (jika ada).</li>
                <li>Kerjakan Post-Test setelah menonton video.</li>
              </ul>
            </li>
            <li>Kelas akan dianggap selesai jika progress mencapai 100%.</li>
          </ul>
          <p>Catatan: Pastikan login menggunakan email yang digunakan saat pembayaran.</p>
        </div>
      ),
    },
    {
      q: <p>Bagaimana Cara Dinyatakan Lulus dari Kelas?</p>,
      a: (
        <div>
          <p>
            Kamu dinyatakan lulus apabila memperoleh nilai minimal 60. Setelah itu kamu akan
            menerima sertifikat kelulusan dari MyEduSolveX.
          </p>
        </div>
      ),
    },
    {
      q: <p>Bagaimana Jika Nilai Saya Kurang dari 60?</p>,
      a: (
        <div>
          <p>
            Kamu dapat mengikuti retake exam untuk memperbaiki nilai. Nilai maksimal retake adalah
            60.
          </p>
        </div>
      ),
    },
    {
      q: <p>Bagaimana Cara Mengunduh Sertifikat E-Learning?</p>,
      a: (
        <div>
          <p>Ikuti langkah berikut untuk men-download sertifikat:</p>
          <ul>
            <li>Tonton semua video sampai selesai.</li>
            <li>Kerjakan Pre-Test & Post-Test minimal skor 60.</li>
            <li>Isi rating & ulasan di bagian bawah halaman course.</li>
            <li>
              Sertifikat akan otomatis muncul di menu Kelas Saya → Sertifikat, lalu klik “Download”.
            </li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className="container">
      <FaqContainer>
        <HeaderTitle>Frequently Asked Questions</HeaderTitle>

        {listFaq.map((item, idx) => (
          <FaqItem key={idx}>
            <FaqQuestion
              isOpen={openIndex === idx}
              onClick={() => {
                toggleFaq(idx);
                trackEvent({
                  eventName: 'view_faq',
                  params: {
                    question: item?.q ?? '-',
                  },
                });
              }}
            >
              {item.q}
              <span className="arrow">
                {openIndex === idx ? (
                  <ArrowUpOutlined size={10} width={10} height={10} />
                ) : (
                  <ArrowDownOutlined size={10} width={10} height={10} />
                )}
              </span>
            </FaqQuestion>

            <Collapse isOpened={openIndex === idx}>
              <FaqAnswer>{item.a}</FaqAnswer>
            </Collapse>
          </FaqItem>
        ))}
      </FaqContainer>
    </div>
  );
}

/* ======================= STYLED COMPONENTS ======================= */

const FaqContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
`;

const HeaderTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 30px;
`;

const FaqItem = styled.div`
  padding: 0;
  margin-bottom: 10px;
`;

const FaqQuestion = styled.button`
  width: 100%;
  background: ${(props) => (props.isOpen ? '#000000' : '#000000')};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 18px 20px;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s ease;

  .arrow {
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 4px;
    margin-left: 12px;
    background: #1f2937;
  }

  &:hover {
    background: #111827;
  }
`;

const FaqAnswer = styled.div`
  padding: 15px 20px 20px 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  background: #f9fafb;

  ul {
    margin-left: 20px;
    list-style-type: disc;
  }

  a {
    color: #2563eb;
    text-decoration: underline;
  }
`;
